import { useState } from "react";
import styles from "./StockProductsTab.module.css";
import CustomSelect from "../../customComponents/CustomSelect";
import {
  FaCashRegister,   // для "Возможные продажи"
  FaCoins,          // для "Возможная прибыль"
  FaTruckLoading,   // для "Сумма закупки"
  FaShoppingBag,    // для "Количество продаж"
  FaCog,
} from "react-icons/fa";

const StockProductsTab = () => {
  const [Select, setSelect] = useState("");

  return (
    <div className={styles.container}>
      {/* Верхние карточки */}
      <div className={styles.stats}>
        <div className={`${styles.card} ${styles.blue}`}>
          <div className={styles.cardIcon}>
            <FaCashRegister />
          </div>
          <div>
            <p>Возможные продажи</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={`${styles.card} ${styles.green}`}>
          <div className={styles.cardIcon}>
            <FaCoins />
          </div>
          <div>
            <p>Возможная прибыль</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={`${styles.card} ${styles.orange}`}>
          <div className={styles.cardIcon}>
            <FaTruckLoading />
          </div>
          <div>
            <p>Сумма закупки</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={`${styles.card} ${styles.purple}`}>
          <div className={styles.cardIcon}>
            <FaShoppingBag />
          </div>
          <div>
            <p>Количество продаж</p>
            <h3>0 шт</h3>
          </div>
        </div>
      </div>

      {/* Фильтры */}
      <div className={styles.filters}>
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1", "Select 2", "Select 3", "Select 4"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1", "Select 2", "Select 3", "Select 4"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1", "Select 2", "Select 3", "Select 4"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <input
          type="text"
          placeholder="Наименование товара"
          className={styles.input}
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1", "Select 2", "Select 3", "Select 4"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1", "Select 2", "Select 3", "Select 4"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
      </div>

      {/* Таблица */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Артикул</th>
              <th>Название</th>
              <th>Единица измерения</th>
              <th>Остаток</th>
              <th>Цена закупки</th>
              <th>Цена продажи</th>
              <th>
                <FaCog />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="7" className={styles.emptyText}>
                Здесь пусто
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockProductsTab;
